import React from "react";

export default function CorporationTaxView({ data, preview_url }) {
  if (!data) return null;

  return (
    <>
      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3] ">
        <h2 className="text-lg font-semibold">Corporation Tax Details</h2>
      </div>

      {/* Client + Tax Info */}
      <div className="border border-t-0 rounded-b-lg p-4 grid grid-cols-2 gap-6 bg-white shadow">
        <div>
          <h3 className="font-semibold mb-2">Client Information</h3>
          <p><b>Client Name:</b> {data.client_name || "N/A"}</p>
          <p><b>Company Name:</b> {data.company_name || "N/A"}</p>
          <p>
            <b>Filename:</b>{" "}
            {data.uploaded_file?.name || "N/A"}
          </p>
        </div>

        <div>
          <h3 className="font-semibold mb-2">Tax Details</h3>
          <p><b>Tax Period:</b> {data.tax_period_date || "N/A"}</p>
          <p><b>Tax Reference No:</b> {data.tax_reference_no || "N/A"}</p>
          <p><b>Upload Date:</b> {data.upload_date || "N/A"}</p>
        </div>
      </div>

      {/* Tax Summary */}
      {data.tax_summary && (
        <div
          className="mt-4 p-3 border rounded-lg text-black"
          style={{ background: "aliceblue" }}
        >
          <h3 className="font-semibold mb-2">Tax Summary</h3>
          <p><b>Tax Payable:</b> {data.tax_summary.tax_payable || "N/A"}</p>
          <p><b>Tax Paid:</b> {data.tax_summary.tax_paid || "N/A"}</p>
          <p><b>Tax Outstanding:</b> {data.tax_summary.tax_outstanding || "N/A"}</p>
          <p><b>Filing Date:</b> {data.tax_summary.filing_date || "N/A"}</p>
          <p><b>Status:</b> {data.tax_summary.status || "N/A"}</p>
        </div>
      )}

      {/* Payment Records */}
      {Array.isArray(data.payment_records) && data.payment_records.length > 0 && (
        <div className="border bg-white shadow mt-6">
          <h3 className="w-full text-left p-3 bg-[#5a6db3] ">
            Payment Records
          </h3>

          <div className="overflow-x-auto">
            <table className="w-full border rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 text-left border">Date</th>
                  <th className="px-4 py-2 text-left border">Reference</th>
                  <th className="px-4 py-2 text-right border">Amount</th>
                  <th className="px-4 py-2 text-right border">Method</th>
                </tr>
              </thead>
              <tbody>
                {data.payment_records.map((record, idx) => (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{record.date}</td>
                    <td className="px-4 py-2 border">{record.reference}</td>
                    <td className="px-4 py-2 text-right border">
                      {record.amount}
                    </td>
                    <td className="px-4 py-2 text-right border">
                      {record.method}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* PDF Preview */}
      {preview_url && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">
            Uploaded Document Preview
          </h3>
          <iframe
            src={preview_url}
            width="100%"
            height="600"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
            title="PDF Preview"
          />
        </div>
      )}
    </>
  );
}
